import { IPartner } from './Partner';
import { IPaginatedResult, ILocationPoint } from './Util';

export interface IRepresentantFile {
  name?: string;
  key?: string;
  url?: string;
  path?: string;
  _id?: string;
  createdAt?: string;
  updatedAt?: string;
  /* Virtual property used only to store file to be uploaded */
  file?: File;
}

export interface IRepresentantFile {
  name?: string;
  key?: string;
  url?: string;
  path?: string;
  _id?: string;
  createdAt?: string;
  updatedAt?: string;
  /* Virtual property used only to store file to be uploaded */
  file?: File;
}
export interface IRepresentant {
  _id?: string;
  id?: string;
  socialReason: string;
  tradingName: string;
  cnpj: string | null;
  phone: string;
  address?: {
    cep: string;
    street: string;
    complement: string;
    number: string;
    neighborhood: string;
    city: string;
    state: string;
    location?: ILocationPoint;
    completeAddress?: string;
  };
  site: string;
  instagram: string;
  facebook: string;
  cpf: string;
  name: string;
  mobilePhone: string;
  email: string;
  workingState: string[];
  active: boolean;
  code: number | string; // FIXME: Change to string?
  representantUrl: string;
  documents: IRepresentantFile[];
  /* files to be uploaded */
  documentsFiles?: Array<{ file: File }>;
}

export const RepresentantDefaultValues: IRepresentant = {
  cnpj: '',
  socialReason: '',
  phone: '',
  mobilePhone: '',
  address: {
    cep: '',
    city: '',
    complement: '',
    number: '',
    neighborhood: '',
    street: '',
    state: '',
  },
  documents: [],
  documentsFiles: [],
  active: true,
  code: '',
  cpf: '',
  email: '',
  facebook: '',
  instagram: '',
  name: '',
  representantUrl: '',
  site: '',
  tradingName: '',
  workingState: [],
};

export type IRepresentantResult = IPaginatedResult<IRepresentant>;

export type IRepresentantPartnersResult = IPaginatedResult<IPartner>;
